import React, { Component } from 'react'
import { MDBContainer, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter, MDBAlert, MDBSelect , MDBInput, MDBIcon  } from 'mdbreact';
import { MDBSelectInput, MDBSelectOptions, MDBSelectOption } from "mdbreact";
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip  } from 'antd';
import Swal from 'sweetalert2'
import { URL,api } from '../../api';

export default class Modalexpercommentbackexrob2 extends Component {
    constructor(props) {
        super(props);
this.state = {
  modal: false,

   inside:"",
   faculty:"",
   Expert:[],
   idExpert:"",


   id_send:"",//
   id_comment:"",//
   id_bn:"",//
   comment_bn:"",//
   statuscomment_bn:"",//
   filewordcomment_bn:null,//

}

this.handleChange = this.handleChange.bind(this);
this.handleChange2 = this.handleChange2.bind(this);
this.handleSubmit = this.handleSubmit.bind(this);
this.handleSubmitpass = this.handleSubmitpass.bind(this);
this.getExpert = this.getExpert.bind(this);
this.toggle = this.toggle.bind(this);
this.handleChangetype = this.handleChangetype.bind(this);
}


toggle = () => {
  this.setState({
    modal: !this.state.modal
  });
 // this.getExpert()

 //this.props.selectex();
}

handleChangetype(event) {    this.setState({comment_bn: event.target.value});  }


 componentDidMount() {
    //   const { id_send } = this.props.id_send
    //   console.log(id_send);
       this.setState({ id_send:this.props.id_send,
                       id_comment:this.props.id_comment,
                       id_bn:this.props.id_bn,
        })
    //   this.setState({ id_bn:this.props.expert_id})
    //   setTimeout(() => {
    //     //ภายใน
    //      Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
    //     .then(res => {
    //       console.log(res);
    //     //  this.setState({ bankname: res.data, loading: false })
    //       this.setState({ Expert: res.data})
    //     }) 

    //   }, 0);

  }

  getExpert() {
    setTimeout(() => {
    //  const { id_send } = this.props.id_send
     // this.setState({ id_send:this.props.id_send})
      //ภายใน
       Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpert.php')
      .then(res => {
        console.log(res);
      //  this.setState({ bankname: res.data, loading: false })
        this.setState({ Expert: res.data})
      }) 

    }, 0);

}

handleChange(event) {    this.setState({statuscomment_bn: event.target.value});  }
 // handleChange(event) {    this.setState({fileexpert: event.target.files[0]});  }
  handleChange2(event) {    this.setState({filewordcomment_bn: event.target.files[0]});  }


  handleSubmit() {
    // alert('A name was submitted: ' + this.state.value);

    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

   setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id_sendarticle", this.state.id_send);
      datafrm.append("id_commentex", this.state.id_comment);
      datafrm.append("id_experten", this.state.id_bn);
      datafrm.append("statuscomment_expert", this.state.statuscomment_bn);
      datafrm.append("date_senbackexpert", dates);
      datafrm.append("filewordcomment_expert", this.state.filewordcomment_bn);
      
      api.post("registercon/Insertfileexpertexcommentlistrob2",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
   
  
    if (res.data = '200') {
        Swal.fire({
         title: 'บันทึกข้อเสนอแนะสำเร็จ',
         text: "Suggestion saved successfully",
         icon: 'success',
         showCancelButton: false,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'ตกลง'
       }).then((result) => {
         if (result.isConfirmed) {
             this.props.list()
             this.toggle()
         }
       })
       
       }else{
             message.error("อัพโหลไฟล์ไม่สำเร็จ!")
       }
  })




}, 1000);

  //this.props.updateat();
 // this.toggle()
  //this.getExpert()

  }



  handleSubmitpass() {
    // alert('A name was submitted: ' + this.state.value);

    const date = new Date();
    const [month, day, year]  = [String(date.getMonth() + 1).padStart(2, '0'), String(date.getDate()).padStart(2, '0'), date.getFullYear()];
    const dates = day+"-"+month+"-"+year ;

   // console.log(dates)
   setTimeout(() => {
      const datafrm = new FormData(); //สร้างฟอร์มสำหรับการส่งข้อมูล
      datafrm.append("id_sendarticle", this.state.id_send);
      datafrm.append("id_commentex", this.state.id_comment);
      datafrm.append("id_experten", this.state.id_bn);
      datafrm.append("statuscomment_expert", this.state.statuscomment_bn);
      datafrm.append("date_senbackexpert", dates);

      
      api.post("registercon/updateexpertcommentlistrob2",datafrm,{
    headers: {
        'content-type': 'multipart/form-data'
    }
   })

   .then(res => {
   
  
    if (res.data = '200') {
        Swal.fire({
         title: 'บันทึกข้อเสนอแนะสำเร็จ',
         text: "Suggestion saved successfully",
         icon: 'success',
         showCancelButton: false,
         confirmButtonColor: '#3085d6',
         cancelButtonColor: '#d33',
         confirmButtonText: 'ตกลง'
       }).then((result) => {
         if (result.isConfirmed) {
             this.props.list()
             this.toggle()
         }
       })
       
       }else{
             message.error("อัพโหลไฟล์ไม่สำเร็จ!")
       }
  })
}, 1000);
  }

  

    render() {

      // console.log(this.state.id_bn);
      // console.log(this.state.id_comment)
      // console.log(this.state.id_send)
      
        

        return (
            <>
            <MDBBtn color="deep-purple" onClick={this.toggle} size='sm'>อัพโหลดข้อเสนอหลังผู้ทรงพิจารณา</MDBBtn>
            <MDBModal isOpen={this.state.modal} toggle={this.toggle}>
              <MDBModalHeader toggle={this.toggle}>
              อัพโหลดข้อเสนอ
                {/* {this.props.namearticla}{this.props.id_send} */}
                </MDBModalHeader>
              <MDBModalBody>
              <div>

              {/* <div className="mb-2">
                           <label><strong>ข้อเสนอแนะ</strong></label>
                           <input className="form-control" onChange={this.handleChangetype} name="comment_bn"
                                    value={this.state.comment_bn} placeholder="กรุณาระบุจำนวนเงิน" required />
              </div> */}
               <div className="mb-2">
               <label><strong>แจ้งสถานะบทความ</strong></label>
                <select className="browser-default custom-select" onChange={this.handleChange}>
                        <option>------กรุณาเลือกสถานะบทความ------</option>
                        <option value="1">ผ่าน</option>
                        <option value="2">ปรับแก้ไข</option>
                </select>
                </div>

              {/* <p>อัพโหลดไฟล์แบบประเมิน .word</p>
                <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                        success="right"  name="file2" value={this.state.value} onChange={this.handleChange2} required/> */}
{this.state.statuscomment_bn === '1' ?<>

</>:<>

{this.state.statuscomment_bn === '2' ?<>
 <div className="mb-2">
                            <label><strong>อัพโหลดไฟล์แบบประเมิน .pdf <MDBIcon icon="file-pdf" /> .pdf</strong></label>
                                {/* <MDBInput  icon="file-upload" group   type="file" validate error="wrong"
                                 success="right"  name="file" value={this.state.value} onChange={this.handleChange3}/> */}
                                  <input
                                        type="file"
                                        name="file" value={this.state.value} onChange={this.handleChange2}
                                        className="form-control"
                                        id="formGroupExampleInput"
                                        accept="application/pdf,*"
                                        required />
                            </div>
                            <div className="mb-2">
                           <label><strong>ข้อเสนอแนะ</strong></label>
                           <input className="form-control" type='text'  onChange={this.handleChangetype} name="comment_bn"
                                    value={this.state.comment_bn} placeholder="กรุณาระบุข้อเสนอแนะ" required />
              </div>

</>:<></>}
</>}

               
                      
            
              </div>

              </MDBModalBody>

             
              <MDBModalFooter>
               
                {this.state.statuscomment_bn === '1'?<>
                <MDBBtn color="primary" onClick={this.handleSubmitpass} >บันทึก</MDBBtn>
                </>:<>
                {this.state.statuscomment_bn === '2' ?<>
                 {this.state.filewordcomment_bn === null  ? <><MDBBtn color="primary" disabled >บันทึก</MDBBtn> </> :<>  <MDBBtn color="primary" onClick={this.handleSubmit} >บันทึก</MDBBtn></> }
                </>:<>
                <MDBBtn color="primary" disabled >บันทึก</MDBBtn> 
                </>}
                </>}

                <MDBBtn color="secondary" onClick={this.toggle}>ปิด</MDBBtn>
              
              </MDBModalFooter>
            </MDBModal>
          </>
          
        )
    }
}


